import React, { Component } from 'react';
import {
  SFCMenuItemContainer,
  ItemImage,
  ItemInfo,
  ItemInfoHeader,
  ItemInfoData,
  ItemInfoOpacity,
  ItemURL,
  TitleWrapper,
  ItemA
} from './SFCMenuItemElement';
import { Slider } from './Slider';
import { getTranslatedKey } from '../Utils/TranslateUtils';

export class SFCMenuItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <SFCMenuItemContainer key={this.props.keyId} show={this.props.show} title={this.props.infoMiniaturaCarto}>
          <ItemImage
            id={this.props.infoMiniaturaCarto}
            className={this.props.infoMiniaturaCarto}
            src={this.props.miniaturaCarto}
            alt={this.props.altMiniaturaCarto}
            selected={this.props.fonsActiu === this.props.keyId}
            onClick={() => this.props.onClickFonsMapa(this.props.keyId)}
          />
          <ItemInfo fontSizeEnabled={this.props.fontSizeEnabled}>
            <TitleWrapper>
              <ItemInfoHeader onClick={() => this.props.onClickFonsMapa(this.props.keyId)} fontSizeEnabled={this.props.fontSizeEnabled}>
                {this.props.infoMiniaturaCarto}
              </ItemInfoHeader>
            </TitleWrapper>
            <>
              <ItemInfoData fontSizeEnabled={this.props.fontSizeEnabled}>
                {this.props.url && (
                  <ItemURL title={getTranslatedKey('moreInfo')}>
                    <ItemA href={this.props.url} target="_blank" rel="noreferrer">
                      {this.props.dataMiniaturaCarto}
                      <div>
                        <svg
                          id="NewTab"
                          y="-3px"
                          viewBox="0 0 20 20"
                          fill="white"
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          x="0px"
                          width="12">
                          <g>
                            <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z"></path>
                            <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z"></path>
                          </g>
                        </svg>
                      </div>
                    </ItemA>
                  </ItemURL>
                )}
              </ItemInfoData>
            </>
            <ItemInfoOpacity>
              <Slider
                aria-label={getTranslatedKey('aria_sliderMap')}
                name={this.props.infoMiniaturaCarto}
                fonsActiu={this.props.fonsActiu}
                transparenciaFons={this.props.transparenciaFons}
                onChangeTransparenciaMapa={(i, transp) => this.props.onChangeTransparenciaMapa(i, transp)}
                enabled={this.props.fonsActiu === this.props.keyId}
                sliderWidth={this.props.sliderWidth}></Slider>
            </ItemInfoOpacity>
          </ItemInfo>
        </SFCMenuItemContainer>
      </>
    );
  }
}
